import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.array.some";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.function.name";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.set";
import "core-js/modules/es.string.includes";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";
import _defineProperty from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _toConsumableArray from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/mzkj/\u8981\u70BC/yl-pc-business/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var initForm = {
  goodsName: '',
  goodsSlogan: '',
  brandId: '',
  refundWithoutReason: '',
  exchangeGoods: '',
  goodsModel: '',
  sellAttributes: [],
  goodsImages: [],
  goodsPrimaryVideo: '',
  goodsContentApp: '',
  deliveryFeeId: '',
  storeGoodsTypeId: '',
  storeGoodsTypeFirst: '',
  packingList: '',
  afterSaleService: '',
  onlyVatInvoice: false,
  autoOnShelf: false,
  autoOffShelf: false,
  autoOnShelfTime: '',
  autoOffShelfTime: '',
  goodsStatus: '',
  goodsItems: []
};
var tabDefalut = [{
  label: '商品条形码',
  prop: 'goodsBarcode',
  edit: true,
  type: 'd2Input'
}, {
  label: '出售价',
  prop: 'goodsPrice',
  edit: true,
  type: 'd2Input'
}, {
  label: '库存',
  prop: 'goodsStock',
  edit: true,
  type: 'd2Input'
}, {
  label: '重量（可不填）',
  prop: 'goodsWeight',
  edit: true,
  type: 'd2Input'
}, {
  label: '商家SKU（可不填）',
  prop: 'goodsSku',
  edit: true,
  type: 'd2Input'
}];
import { cloneDeep } from 'lodash';
import editTable from '../comps/editTable.vue';
import uploadVideo from '../comps/uploadVideo.vue';
import setRules from '@/libs/rules';
var rule = [// { key: 'accountPhone', name: '手机号码', validator: 'validatePhone' },
{
  key: 'goodsName',
  name: '商品名称'
}, {
  key: 'goodsSlogan',
  name: '商品标语'
}, {
  key: 'refundWithoutReason'
}, {
  key: 'exchangeGoods'
}, {
  key: 'goodsContentApp'
}, {
  key: 'deliveryFeeId'
}];
export default {
  meta: {
    title: '编辑商品信息',
    auth: true,
    authorityValue: "store-offshelf-manage"
  },
  name: 'editTrade',
  components: {
    editTable: editTable,
    uploadVideo: uploadVideo
  },
  data: function data() {
    return {
      brandOptions: [],
      //品牌列表
      tableProp: cloneDeep(tabDefalut),
      treeOptions: [],
      defaultProps: {
        label: 'typeName',
        value: 'goodsTypeId',
        lazy: true,
        lazyLoad: this.treeLoad
      },
      deliveryOptions: [],
      formData: cloneDeep(initForm),
      rules: setRules(rule),
      checked: true,
      imgAttr: {
        width: 90,
        height: 90,
        isSingle: true
      },
      imgAttrs: {
        width: 90,
        height: 90,
        limit: 10,
        tradeList: true
      },
      attrList: [],
      cascaderProps: {
        lazy: true,
        lazyLoad: this.lazyLoad,
        label: 'typeName',
        value: 'goodsTypeId',
        leaf: 'leaf',
        checkStrictly: true
      },
      store_value: [],
      store_key: false,
      cascader_value: [],
      cascader_key: 0,
      dataList: []
    };
  },
  computed: {
    deliveryTip: function deliveryTip() {
      var _this = this;

      if (!this.formData.deliveryFeeId) return;
      var item = this.deliveryOptions.find(function (v) {
        return v.deliveryFeeId == _this.formData.deliveryFeeId;
      });
      if (!item) return;
      var t = "\u6309\u91CD\u91CF\uFF1A\u9ED8\u8BA4\u8FD0\u8D39".concat(item.baseCount, "\u5343\u514B\uFF08kg\uFF09\u5185").concat(item.basePrice, "\u5143\uFF0C\u6BCF\u589E\u52A0").concat(item.incrementCount, "\u5343\u514B\uFF08kg\uFF09\uFF0C\u589E\u52A0\u8FD0\u8D39").concat(item.incrementPrice, "\u5143");
      var g = "\u6309\u4EF6\u6570\uFF1A\u9ED8\u8BA4\u8FD0\u8D39".concat(item.baseCount, "\uFF08\u4EF6\uFF09\u5185").concat(item.basePrice, "\u5143\uFF0C\u6BCF\u589E\u52A0").concat(item.incrementCount, "\uFF08\u4EF6\uFF09\uFF0C\u589E\u52A0\u8FD0\u8D39").concat(item.incrementPrice, "\u5143");
      var tit = item.feeType == 1 ? g : t;
      return item.freed ? '卖家承担' : tit;
    },
    deliveryName: function deliveryName() {
      var _this2 = this;

      if (!this.formData.deliveryFeeId) return;
      var item = this.deliveryOptions.find(function (v) {
        return v.deliveryFeeId == _this2.formData.deliveryFeeId;
      });
      return item.deliveryFeeName;
    }
  },
  methods: {
    lazyLoad: function lazyLoad(node, resolve) {
      var level = node.level,
          data = node.data;
      var obj = {
        typeLevel: level + 1,
        preTypeId: data === null || data === void 0 ? void 0 : data.goodsTypeId
      };
      this.getGoodsTypes(obj, resolve);
    },
    //获取类目
    getGoodsTypes: function getGoodsTypes(data, resolve) {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var res, o;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this3.$api.goodsTypes(_objectSpread({
                  pageNo: 1,
                  pageSize: 99
                }, data));

              case 2:
                res = _context.sent;
                o = cloneDeep(res.records);
                resolve(o);

                _this3.$refs.cascader.computePresentText();

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    onSubmit: function onSubmit(item) {
      var _this4 = this;

      if (this.formData.goodsPrimaryVideo && !this.formData.goodsPrimaryVideoCover) {
        YL.message('上传视频请同步上传视频封面', 'error');
        return;
      }

      if (!this.formData.goodsPrimaryVideo && this.formData.goodsPrimaryVideoCover) {
        YL.message('上传视频封面请同步上传视频', 'error');
        return;
      }

      this.$refs.formData.validate( /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(valid) {
          var params, _yield$_this4$$api$de, records, noWeight, goodsImages;

          return regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) {
              switch (_context2.prev = _context2.next) {
                case 0:
                  if (valid) {
                    _context2.next = 2;
                    break;
                  }

                  return _context2.abrupt("return");

                case 2:
                  params = _objectSpread(_objectSpread(_objectSpread({}, _this4.formData), item), {}, {
                    sellAttributes: _this4.attrList
                  });
                  console.log('params', params);
                  console.log('this.attrList ', _this4.attrList);
                  params['goodsTypeIdFirst'] = _this4.cascader_value[0];
                  params['goodsTypeIdSecond'] = _this4.cascader_value[1];
                  params['goodsTypeId'] = _this4.cascader_value[2]; //获取运费模板

                  _context2.next = 10;
                  return _this4.$api.deliveryFees(_objectSpread({
                    pageSize: 999
                  }, item));

                case 10:
                  _yield$_this4$$api$de = _context2.sent;
                  records = _yield$_this4$$api$de.records;
                  // 判断选择的运费模板是否是按重量
                  noWeight = true;
                  records.forEach(function (e) {
                    if (e.deliveryFeeId === params.deliveryFeeId) {
                      console.log('运费方式', e.feeType);

                      if (e.feeType === 2) {
                        params.goodsItems.forEach(function (_e) {
                          if (_e.goodsWeight == '') noWeight = false;
                        });
                      }
                    }
                  });

                  if (noWeight) {
                    _context2.next = 16;
                    break;
                  }

                  return _context2.abrupt("return", _this4.$message.error('由于您选择按重量计算运费，请完善商品重量'));

                case 16:
                  // 过滤商品图片数组中的null
                  goodsImages = [];
                  params.goodsImages.forEach(function (e) {
                    if (e !== null) {
                      goodsImages.push(e);
                    }
                  });
                  params.goodsImages = goodsImages;
                  _context2.next = 21;
                  return _this4.$api.saveGoods(params);

                case 21:
                  YL.message('保存成功');

                  _this4.goBack();

                  if (item.goodsStatus == 1) _this4.$router.replace('/saleTrade');else _this4.$router.replace('/comsTrade');

                case 24:
                case "end":
                  return _context2.stop();
              }
            }
          }, _callee2);
        }));

        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    tabDelete: function tabDelete(item, $index) {
      this.formData.goodsItems.splice($index, 1);
    },
    imgEmit: function imgEmit(list) {
      console.log(list);
    },
    imgEmits: function imgEmits(list) {
      console.log(list);
    },
    d2Upload: function d2Upload() {
      this.$refs.d2Upload.elUploadClick(null, null);
    },
    //获取品牌列表
    getBrands: function getBrands() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _yield$_this5$$api$br, records, record;

        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this5.$api.brands({
                  pageSize: 999
                });

              case 2:
                _yield$_this5$$api$br = _context3.sent;
                records = _yield$_this5$$api$br.records;
                record = [];
                records.forEach(function (e) {
                  if (e.brandActivate) {
                    record.push(e);
                  }
                });
                _this5.brandOptions = record;

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    //添加规格值
    addSellAttributes: function addSellAttributes(item) {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this6.$prompt('添加后不可删除，请谨慎添加', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  inputPattern: /\S/,
                  inputErrorMessage: '不可为空'
                }).then( /*#__PURE__*/function () {
                  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(_ref2) {
                    var value, params;
                    return regeneratorRuntime.wrap(function _callee4$(_context4) {
                      while (1) {
                        switch (_context4.prev = _context4.next) {
                          case 0:
                            value = _ref2.value;
                            params = {
                              sellAttributeId: item.sellAttributeId,
                              itemValue: value,
                              itemSort: 0
                            };
                            _context4.next = 4;
                            return _this6.$api.saveSellAttributeItem(params);

                          case 4:
                            _this6.getSellAttributes();

                          case 5:
                          case "end":
                            return _context4.stop();
                        }
                      }
                    }, _callee4);
                  }));

                  return function (_x2) {
                    return _ref3.apply(this, arguments);
                  };
                }());

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    },
    //等待数据
    setAttrList: function setAttrList(records, id) {
      var _this7 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee7() {
        return regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                cloneDeep(records).forEach( /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6(v, i) {
                    var params, data, len;
                    return regeneratorRuntime.wrap(function _callee6$(_context6) {
                      while (1) {
                        switch (_context6.prev = _context6.next) {
                          case 0:
                            params = {
                              sellAttributeId: v.sellAttributeId,
                              pageSize: 1000 * 1000
                            };
                            _context6.next = 3;
                            return _this7.$api.sellAttributeDetails(params);

                          case 3:
                            data = _context6.sent;
                            data.items.map(function (m) {
                              m.selected = _toConsumableArray(id).includes(m.sellAttributeItemId);
                            });

                            _this7.attrList.push(data);

                            len = _this7.attrList.length === records.length;

                            _this7.isLoaded(len).then(function () {
                              return _this7.changeCheckbox('edit', {
                                itemValue: ''
                              });
                            });

                          case 8:
                          case "end":
                            return _context6.stop();
                        }
                      }
                    }, _callee6);
                  }));

                  return function (_x3, _x4) {
                    return _ref4.apply(this, arguments);
                  };
                }());
                return _context7.abrupt("return", true);

              case 2:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }))();
    },
    //获取属性列表
    getSellAttributes: function getSellAttributes() {
      var _this8 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee8() {
        var ids, id, _yield$_this8$$api$se, records;

        return regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _this8.attrList = [];
                ids = [];

                _this8.formData.sellAttributeList.forEach(function (v) {
                  var list = v.items.filter(function (f) {
                    return f.validItemIds.length > 0;
                  });
                  ids.push.apply(ids, _toConsumableArray(list.map(function (m) {
                    return m.validItemIds.map(function (l) {
                      return l;
                    });
                  })));
                });

                id = new Set();
                ids.forEach(function (v) {
                  return v.forEach(function (k) {
                    return id.add(k);
                  });
                });
                _context8.next = 7;
                return _this8.$api.sellAttributes({
                  goodsTypeId: _this8.formData.goodsTypeId ? _this8.formData.goodsTypeId : _this8.formData.goodsTypeIdSecond ? _this8.formData.goodsTypeIdSecond : _this8.formData.goodsTypeIdFirst ? _this8.formData.goodsTypeIdFirst : ''
                });

              case 7:
                _yield$_this8$$api$se = _context8.sent;
                records = _yield$_this8$$api$se.records;
                _context8.prev = 9;
                _context8.next = 12;
                return _this8.setAttrList(records, id);

              case 12:
                _context8.next = 17;
                break;

              case 14:
                _context8.prev = 14;
                _context8.t0 = _context8["catch"](9);
                _this8.attrList = cloneDeep(records);

              case 17:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, null, [[9, 14]]);
      }))();
    },
    changeCheckbox: function changeCheckbox(e, k) {
      var _this9 = this;

      this.formData.sellAttributes = [];
      this.dataList = cloneDeep(this.formData.goodsItems);
      this.formData.goodsItems = [];
      this.tableProp = cloneDeep(tabDefalut);
      var tableList = [];
      this.attrList.forEach(function (v) {
        if (v.items.some(function (s) {
          return s.selected;
        })) {
          tableList.push(_objectSpread(_objectSpread({}, v), {}, {
            items: v.items.filter(function (f) {
              return f.selected;
            })
          }));
        }
      });
      var tabObj = {};
      tableList.forEach(function (v) {
        tabObj[v.attributeName] = v.items.map(function (m) {
          return m.itemValue;
        });
        var tab = {
          label: v.attributeName,
          prop: v.attributeName,
          width: '100px'
        };

        _this9.tableProp.unshift(tab);
      }); // 循环每一个商品属性

      var result = this.combination(tabObj);
      result.forEach(function (v, i) {
        var obj = _objectSpread(_objectSpread({}, v), {}, {
          goodsItemId: '',
          itemSellAttributes: [],
          goodsBarcode: '',
          goodsPrice: '',
          goodsStock: '',
          goodsWeight: '',
          goodsSku: ''
        });

        _this9.dataList.forEach(function (d) {
          var isold = true;

          for (var key in v) {
            if (v[key] === k.itemValue) {
              if (d[key] !== undefined) {
                isold = false;
              }
            } else {
              if (v[key] !== d[key]) {
                isold = false;
              }
            }
          }

          if (isold) {
            var p = {
              goodsBarcode: d.goodsBarcode,
              goodsPrice: d.goodsPrice,
              goodsStock: d.goodsStock,
              goodsWeight: d.goodsWeight,
              goodsSku: d.goodsSku
            };
            obj = _objectSpread(_objectSpread(_objectSpread({}, obj), p), {}, {
              itemSellAttributes: obj.itemSellAttributes
            });
          }

          if (e == 'edit') {
            var _p = {
              goodsItemId: _this9.dataList[i].goodsItemId,
              goodsBarcode: _this9.dataList[i].goodsBarcode,
              goodsPrice: _this9.dataList[i].goodsPrice,
              goodsStock: _this9.dataList[i].goodsStock,
              goodsWeight: _this9.dataList[i].goodsWeight,
              goodsSku: _this9.dataList[i].goodsSku
            };
            obj = _objectSpread(_objectSpread(_objectSpread({}, obj), _p), {}, {
              itemSellAttributes: obj.itemSellAttributes
            });
          }
        });

        _this9.formData.goodsItems.push(obj);
      });
      this.dataList = cloneDeep(this.formData.goodsItems);
      this.attrList.forEach(function (v) {
        _this9.formData.goodsItems.forEach(function (f) {
          Object.keys(f).forEach(function (k) {
            if (v.attributeName == k) {
              var item = v.items.find(function (s) {
                return s.itemValue == f[k];
              });
              f.itemSellAttributes.push(item);
            }
          });
        });
      });
      this.formData.sellAttributes = tableList;
      this.$forceUpdate();
    },
    //排列组合
    combination: function combination(tabObj) {
      return Object.keys(tabObj).reduce(function (result, key) {
        // 循环属性的每一个值
        return tabObj[key].reduce(function (acc, value) {
          // 对于第一个属性
          if (!result.length) {
            // 将数值转化为对象格式
            return acc.concat(_defineProperty({}, key, value));
          } // 对于第一个之后的属性，将新的属性和值添加到已有结果，并进行拼接。


          return acc.concat(result.map(function (ele) {
            return Object.assign({}, ele, _defineProperty({}, key, value));
          }));
        }, []);
      }, []);
    },
    //获取店内分类
    storeGoodsTypes: function storeGoodsTypes(item, resolve) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee9() {
        var _yield$_this10$$api$s, records;

        return regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.next = 2;
                return _this10.$api.storeGoodsTypes(_objectSpread({
                  pageSize: 999
                }, item));

              case 2:
                _yield$_this10$$api$s = _context9.sent;
                records = _yield$_this10$$api$s.records;
                resolve && resolve(records);

                _this10.$refs.store_cascader.computePresentText();

              case 6:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9);
      }))();
    },
    treeLoad: function treeLoad(e, resolve) {
      var params = {
        typeLevel: 1
      };

      if (e) {
        params = _objectSpread(_objectSpread({}, params), {}, {
          preTypeId: e.value,
          typeLevel: e.value ? '' : 1
        });
      }

      this.storeGoodsTypes(params, resolve);
    },
    treeCheck: function treeCheck(e) {
      e[0] && this.$set(this.formData, 'storeGoodsTypeFirst', e[0]);
      e[1] && this.$set(this.formData, 'storeGoodsTypeId', e[1]);
    },
    //获取运费模板
    deliveryFees: function deliveryFees(item) {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee10() {
        var _yield$_this11$$api$d, records;

        return regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.next = 2;
                return _this11.$api.deliveryFees(_objectSpread({
                  pageSize: 999
                }, item));

              case 2:
                _yield$_this11$$api$d = _context10.sent;
                records = _yield$_this11$$api$d.records;
                _this11.deliveryOptions = records;

              case 5:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10);
      }))();
    },
    //获取详情
    goodsDetails: function goodsDetails(item) {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee11() {
        var res;
        return regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _this12.store_key = true;
                _context11.next = 3;
                return _this12.$api.goodsDetails(item);

              case 3:
                res = _context11.sent;
                _this12.store_key = false;

                _this12.$nextTick(function () {
                  res['goodsTypeIdFirst'] && _this12.cascader_value.push(res['goodsTypeIdFirst']);
                  res['goodsTypeIdSecond'] && _this12.cascader_value.push(res['goodsTypeIdSecond']);
                  res['goodsTypeId'] && _this12.cascader_value.push(res['goodsTypeId']);
                  res['storeGoodsTypeFirst'] && _this12.store_value.push(res['storeGoodsTypeFirst']);
                  res['storeGoodsTypeId'] && _this12.store_value.push(res['storeGoodsTypeId']);
                  _this12.cascader_key += 1;
                  _this12.formData = Object.assign(_this12.formData, _objectSpread({}, res));
                  _this12.store_key = true;
                });

              case 6:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }))();
    },
    // 图片上传
    handleSuccess: function handleSuccess(response, key) {
      this.$set(this.formData, key, this.VUE_APP_IMG_BASE + response.key);
      console.log('this.formData', this.formData);
      this.$forceUpdate(); // this.$refs['layerForm'].clearValidate(key)
    },
    beforeUpload: function beforeUpload(file) {
      if (!YL.beforeUploadCommon(file, 'pic')) return false;
      this.uploadData.data.key = new Date().getTime() + YL.catchType(file.name);
    },
    delVideoCover: function delVideoCover() {
      this.$set(this.formData, 'goodsPrimaryVideoCover', '');
      this.$forceUpdate();
    }
  },
  created: function created() {
    var _this13 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee12() {
      var query;
      return regeneratorRuntime.wrap(function _callee12$(_context12) {
        while (1) {
          switch (_context12.prev = _context12.next) {
            case 0:
              _context12.next = 2;
              return _this13.getQiNiu();

            case 2:
              query = _this13.$route.query;
              _context12.next = 5;
              return _this13.goodsDetails(query);

            case 5:
              _context12.next = 7;
              return _this13.getBrands();

            case 7:
              _context12.next = 9;
              return _this13.deliveryFees();

            case 9:
              _context12.next = 11;
              return _this13.getSellAttributes();

            case 11:
            case "end":
              return _context12.stop();
          }
        }
      }, _callee12);
    }))();
  }
};